import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { authAPI } from '../services/api';
import { toast } from 'sonner';

const AdminLoginModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('isAdmin');
      localStorage.removeItem('user');

      const response = await authAPI.login({ username: username.trim(), password });
      const { access_token, user } = response.data;
      
      if (user.is_admin) {
        localStorage.setItem('token', access_token);
        localStorage.setItem('isAdmin', 'true');
        localStorage.setItem('user', JSON.stringify(user));
        onLoginSuccess(user);
        toast.success('Connexion réussie! Redirection...');
        setTimeout(() => {
          navigate('/admin');
        }, 500);
      } else {
        toast.error('Accès admin requis');
      }
    } catch (error) {
      const detail = error?.response?.data?.detail || error?.message;
      if (detail) {
        toast.error(typeof detail === 'string' ? detail : 'Erreur de connexion');
      } else {
        toast.error('Identifiants invalides');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full p-6 border border-slate-700 animate-fadeIn">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-white">Connexion Admin</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
            data-testid="close-modal-btn"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Nom d'utilisateur (admin)
            </label>
            <Input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              required
              className="bg-slate-700 border-slate-600 text-white"
              data-testid="username-input"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Mot de passe
            </label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              className="bg-slate-700 border-slate-600 text-white"
              data-testid="password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={isLoading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white"
            data-testid="login-submit-btn"
          >
            {isLoading ? 'Connexion...' : 'Se connecter'}
          </Button>
        </form>

        <p className="mt-4 text-sm text-gray-400 text-center">
          Compte par défaut: admin / admin123
        </p>
      </div>
    </div>
  );
};

export default AdminLoginModal;
